<template>
    <div id="myinfo-email">
      <f7-list form class="form-group">
        <f7-list-input
          input-id      ="email"
          name          ="email"
          type          ="text"
          class         =""
          placeholder   =""
          :value        ="email"
          @input        = "setInputValue($event.target)"
          :label        ="$t('general-text-email')"
          autocomplete  ="off"
          v-show        ="isShow"
          outline
          floating-label
          required
          :disabled    = "isDisabled"
          :clear-button= "!isDisabled"
        ></f7-list-input>
    </f7-list>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    props: {
      isShow:{
        type: Boolean
      },
      isDisabled:{
        type: Boolean
      },
    },
    mounted (){
      
    },
    data: function () {
      return {
      }
    },
    computed: {
      ...mapGetters('myinfo', [
          'email'
      ])
    },
    methods: {
      ...mapActions('myinfo', [
        'setEmail',
        'validateInput'
      ]),

      setInputValue(inputEl){
        this.$emit("setInputValue", inputEl);
      },

      validateNextButton(){
        this.$emit("validateNextButton");
      }
    }
  }
</script>